import BaseHttp from '@/plugins/baseHttp';

const getAdjustments = (params,) => {
  let url = new URLSearchParams();
  Object.entries(params,).forEach(([field,value,],) => {
    if (value) {
      let newField = '';

      if (field == 'competenceDates') {
        newField += field + '[]';
      
        value.forEach((newValue,) => {
          url.append(newField, newValue,);
        },);
      } else {
        url.set(field, value,);
      }
    }
  }, {},);

  return BaseHttp.get(`/occurrences/adjustments?${url.toString()}`,);
};

const handleError = (error,) => {
  return BaseHttp.handleError(error,);
};

const cancelAdjustment = (adjustmentId, data,) => {
  return BaseHttp.post(`/occurrences/adjustments/${adjustmentId}/cancel`, {data, },);
};

const approveAdjusment = (adjustmentId,) => {
  return BaseHttp.post(`/occurrences/adjustments/${adjustmentId}/approve`,);
};

export {
  getAdjustments,
  handleError,
  cancelAdjustment,
  approveAdjusment,
};
